<template>
    <div class="fill-height pa-2">
        <!-- Smartphone -->
        <v-layout wrap>
            <h2>Valider le justificatif</h2>
            <v-flex xs12 sm7 style="display: flex">
                <v-switch
                    v-model="showDocument"
                    hide-details
                    label="Afficher le document"
                    class="my-0 py-1"
                />
                <!-- <v-btn outlined size=“x-small” color="secondary" @click="showDocument = !showDocument" style="margin: 0 auto">Afficher le document</v-btn> -->
                <!-- <v-spacer></v-spacer>
                  <v-btn
                        class="btn"
                        outlined
                         size="small"
                        color="secondary"
                        :disabled="disabledValidate"
                        @click="onFormValidation()"
                    >
                        {{ validated ? 'Validé' : 'Valider' }}
                        <v-icon v-show="validated">$check</v-icon>
                    </v-btn> -->
            </v-flex>
        </v-layout>
        <!-- <v-card elevation-0 style="background-color:transparent;"> -->
        <v-window v-model="step" horizontal class="fill-height">
            <v-window-item :value="0">
                <v-card
                    class="default_card_mobile"
                    style="background-color: transparent"
                    elevation="0"
                >
                    <v-card-title class="title font-weight-regular justify-space-between">
                        <span>{{ wizardStepTitle }}</span>
                        <v-avatar
                            color="primary lighten-2"
                            class="subheading white--text"
                            size="24"
                            v-text="wizardStep"
                        />
                    </v-card-title>
                    <v-window
                        v-model="wizardStep"
                        style="min-height: 27vh"
                        touchless
                        v-if="form.date"
                    >
                        <v-window-item :value="1">
                            <v-card-text class="py-0">
                                <v-list>
                                    <v-list-item
                                        v-for="(type, i) in documentTypeItems"
                                        :key="i"
                                        :class="geDocumentTypeClass(type.type)"
                                        @click.stop="document.type = type.type"
                                    >
                                        <template #prepend>
                                            <v-icon :class="type.iconClass">
                                                {{ type.icon }}
                                            </v-icon>
                                        </template>

                                        <template v-slot:append>
                                            <v-btn>
                                                <v-icon color="primary">{{
                                                    document.type === type.type
                                                        ? "$radio_button_checked"
                                                        : "$radio_button_unchecked"
                                                }}</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list-item-title>
                                            {{ type.title }}
                                        </v-list-item-title></v-list-item
                                    >
                                </v-list>
                                <!-- <v-row justify="space-around">
                                            <v-radio-group v-model="document.type" class="mt-0">
                                                <v-radio
                                                    :label="$t('document.choiceType.PURCHASE_INVOICE')"
                                                    value="PURCHASE_INVOICE"
                                                    color="secondary"
                                                ></v-radio>
                                                <v-radio
                                                    :label="$t('document.choiceType.SALES_INVOICE')"
                                                    value="SALES_INVOICE"
                                                    color="secondary"
                                                ></v-radio>
                                                <v-radio
                                                    :label="$t('document.choiceType.CURRENT_ACCOUNT')"
                                                    value="CURRENT_ACCOUNT"
                                                    color="secondary"
                                                    v-if="legalForm !== 'EI'"
                                                ></v-radio>
                                                <v-radio
                                                    :label="$t('document.choiceType.OPERATOR_ACCOUNT')"
                                                    value="OPERATOR_ACCOUNT"
                                                    color="secondary"
                                                    v-else
                                                ></v-radio>
                                            </v-radio-group>
                                        </v-row>
                                        <v-flex xs12>
                                            <v-select
                                                :items="currentAccountUsers"
                                                :item-title="getUserDisplayName"
                                                item-value="id"
                                                label="Associé"
                                                style="margin: 0 auto"
                                                v-model="currentAccountUser"
                                                return-object
                                                :rules="currentAccountUserRules"
                                                :success="checkCurrentAccountUser"
                                                :error="!checkCurrentAccountUser"
                                                v-if="document.type === 'CURRENT_ACCOUNT' || document.type === 'OPERATOR_ACCOUNT'"
                                            ></v-select>
                                        </v-flex> -->
                            </v-card-text>
                        </v-window-item>
                        <v-window-item :value="8">
                            <v-card-text class="py-0">
                                <SelectUser
                                    v-bind:companyId="companyId"
                                    v-bind:selectedUser="currentAccountUser"
                                    @user-selected="onUserSelected"
                                    v-if="wizardStep === 8"
                                >
                                </SelectUser>
                            </v-card-text>
                        </v-window-item>
                        <v-window-item :value="2">
                            <v-card-text>
                                <v-row justify="space-around">
                                    <v-radio-group v-model="document.creditNote" color="primary">
                                        <v-radio label="Non" :value="false" />
                                        <v-radio label="Oui" :value="true" />
                                    </v-radio-group>
                                </v-row>
                            </v-card-text>
                        </v-window-item>
                        <v-window-item :value="3">
                            <v-card-text style="padding-top: 0">
                                <v-flex class="text-center mb-2">
                                    <v-card
                                        class="default_card_wm mx-auto"
                                        style="background: #fff !important; box-shadow: none"
                                        v-if="document.thirdPartyCompany"
                                    >
                                        <v-card-title primary-title class="py-0">
                                            <div>
                                                {{
                                                    document.thirdPartyCompany
                                                        ? document.thirdPartyCompany.name
                                                        : ""
                                                }}
                                            </div>
                                        </v-card-title>
                                        <v-card-text class="text-left pb-0" v-if="!consumer">
                                            Siret :
                                            {{ getSiretValue(document.thirdPartyCompany.siret) }}
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                                <v-flex
                                    class="text-center mb-2"
                                    v-if="document.type === 'SALES_INVOICE' && !consumer"
                                >
                                    <v-btn
                                        @click="consumer = true"
                                        class="btn"
                                        rounded
                                        size="small"
                                    >
                                        Le client est un particulier
                                    </v-btn>
                                </v-flex>
                                <v-flex class="text-center mb-0">
                                    <v-btn
                                        @click="dialogSelectCompany = true"
                                        class="btn"
                                        rounded
                                        size="small"
                                        >{{ otherThirdPartyCompany }}
                                    </v-btn>
                                </v-flex>
                            </v-card-text>
                        </v-window-item>
                        <v-window-item :value="9">
                            <v-card-text class="py-0">
                                <v-combobox-filled
                                    :items="invoiceNumberList"
                                    :color="form.invoiceNumber.validated ? 'green' : 'red'"
                                    :rules="[form.invoiceNumber.validated || '']"
                                    :success="form.invoiceNumber.validated"
                                    :error="!form.invoiceNumber.validated"
                                    :append-outer-icon="
                                        form.invoiceNumber.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    "
                                    @update:model-value="
                                        onDateChange(form.invoiceNumber, 'invoiceNumber', $event)
                                    "
                                    @keyup.enter="
                                        onDateChange(form.invoiceNumber, 'invoiceNumber', $event)
                                    "
                                    @click:append-outer="
                                        form.invoiceNumber.validated = !form.invoiceNumber.validated
                                    "
                                    @mouseover.native="highlightField(form.invoiceNumber, true)"
                                    @mouseout.native="highlightField(form.invoiceNumber, false)"
                                    outlined
                                    :hide-details="true"
                                    :model-value="form.invoiceNumber.value"
                                />
                            </v-card-text>
                        </v-window-item>
                        <v-window-item :value="4">
                            <v-card-text v-if="form.date">
                                <v-combobox-filled
                                    :items="dateList"
                                    :rules="dateRules"
                                    :prepend-inner-icon="'$vuetify.icons.calendar'"
                                    @update:model-value="onDateChange(form['date'], 'date', $event)"
                                    @keyup.enter="onDateChange(form['date'], 'date', $event)"
                                    @click:prepend-inner="dateDialog = !dateDialog"
                                    @mouseover.native="highlightField(form['date'], true)"
                                    @mouseout.native="highlightField(form['date'], false)"
                                    outlined
                                    required
                                    dense
                                    :model-value="formatObjectDate(form.date)"
                                />
                            </v-card-text>
                        </v-window-item>
                        <v-window-item :value="5">
                            <v-card-text>
                                <v-date-picker-wrapper
                                    locale="fr-FR"
                                    v-model="dueDate"
                                    full-width
                                    :landscape="!$vuetify.display.mobile"
                                    class="elevation-0"
                                    color="secondary"
                                    scrollable
                                />
                            </v-card-text>
                        </v-window-item>
                        <v-window-item :value="6">
                            <v-card-text v-if="form && form.single_prices && form.subAmounts">
                                <v-flex v-if="subjectToVAT">
                                    <!-- <div style="display:flex;"> -->
                                    <div>
                                        <v-flex xs11 class="pa-0">
                                            <v-switch
                                                v-model="multiVat"
                                                label="Multi TVA"
                                                hide-details
                                                :disabled="disabledMultiVat"
                                                class="my-0 pl-2"
                                            />
                                        </v-flex>
                                        <!-- <v-flex xs1 class="pa-0">
                                                    <v-icon
                                                        :color="form.allPricesValidated ? 'green' : 'red'"
                                                        @click="onPricesValidation()"
                                                    >{{ form.allPricesValidated ? '$check_box' : '$check_box_outline_blank' }}</v-icon>

                                                </v-flex> -->
                                    </div>

                                    <!-- <div xs12 style="display:flex;" v-if="showVATType()">
                                                    <v-radio-group
                                                    label="Type de TVA"
                                                    v-model="document.vatType"
                                                    :rules="[ !!document.vatType || 'Type de VAT requise']"
                                                    inline
                                                    required>
                                                        <v-radio label="Aucun" value="NO_VAT_TYPE" color="secondary" v-if="document.type !=='SALES_INVOICE'"></v-radio>
                                                        <v-radio label="Intracom" value="INTRACOM" color="secondary"></v-radio>
                                                        <v-radio label="Export" value="EXPORT"  color="secondary" v-if="document.type ==='SALES_INVOICE'"></v-radio>
                                                        <v-radio label="Import" value="IMPORT"  color="secondary" v-else></v-radio>
                                                        <v-radio label="Autoliquidation" value="REVERSE_CHARGE"  color="secondary"></v-radio>
                                                    </v-radio-group>
                                                </div> -->
                                    <v-row no-gutters>
                                        <v-col cols="12" class="pr-1 pb-1">
                                            <oss-text-field
                                                @update:model-value="
                                                    onMetadataChange(
                                                        form.single_prices.prices,
                                                        '',
                                                        'netAmount',
                                                    )
                                                "
                                                @mouseover="
                                                    highlightField(
                                                        form.single_prices.prices.netAmount,
                                                        true,
                                                    )
                                                "
                                                @mouseout="
                                                    highlightField(
                                                        form.single_prices.prices.netAmount,
                                                        false,
                                                    )
                                                "
                                                :color="
                                                    priceTextColor_amountData(
                                                        form.single_prices.prices,
                                                        true,
                                                    )
                                                "
                                                :rules="[form.allPricesValidated || '']"
                                                :readonly="multiVat"
                                                regular
                                                content-class="oss-"
                                                :hide-details="true"
                                                v-model="form.single_prices.prices.netAmount.value"
                                            >
                                                <template #label>
                                                    HT
                                                    <!-- <span
                                                                v-if="confidence(form.single_prices.prices.netAmount)"
                                                            >
                                                                (
                                                                <span
                                                                    :class="confidence(form.single_prices.prices.netAmount) > 80 ? 'text-green' : 'text-red'"
                                                                >{{`${confidence(form.single_prices.prices.netAmount)}%`}}</span>)
                                                            </span> -->
                                                </template>
                                            </oss-text-field>
                                        </v-col>
                                        <v-col cols="12" class="pb-1">
                                            <oss-text-field
                                                @update:model-value="
                                                    onMetadataChange(
                                                        form.single_prices.prices,
                                                        '',
                                                        'grossAmount',
                                                    )
                                                "
                                                @mouseover="
                                                    highlightField(
                                                        form.single_prices.prices.grossAmount,
                                                        true,
                                                    )
                                                "
                                                @mouseout="
                                                    highlightField(
                                                        form.single_prices.prices.grossAmount,
                                                        false,
                                                    )
                                                "
                                                :color="
                                                    priceTextColor_amountData(
                                                        form.single_prices.prices,
                                                        true,
                                                    )
                                                "
                                                :rules="[form.allPricesValidated || '']"
                                                :readonly="multiVat"
                                                regular
                                                content-class="mr-1 oss-"
                                                :hide-details="true"
                                                v-model="
                                                    form.single_prices.prices.grossAmount.value
                                                "
                                            >
                                                <template #label>
                                                    TTC
                                                    <!-- <span
                                                                v-if="confidence(form.single_prices.prices.grossAmount)"
                                                            >
                                                                (
                                                                <span
                                                                    :class="confidence(form.single_prices.prices.grossAmount) > 80 ? 'text-green' : 'text-red'"
                                                                >{{`${confidence(form.single_prices.prices.grossAmount)}%`}}</span>)
                                                            </span> -->
                                                </template>
                                            </oss-text-field>
                                        </v-col>
                                        <v-col cols="12" class="pr-1 pb-1">
                                            <oss-text-field
                                                @update:model-value="
                                                    onMetadataChange(
                                                        form.single_prices.prices,
                                                        '',
                                                        'vatAmount',
                                                    )
                                                "
                                                @mouseover="
                                                    highlightField(
                                                        form.single_prices.prices.vatAmount,
                                                        true,
                                                    )
                                                "
                                                @mouseout="
                                                    highlightField(
                                                        form.single_prices.prices.vatAmount,
                                                        false,
                                                    )
                                                "
                                                :color="
                                                    priceTextColor_amountData(
                                                        form.single_prices.prices,
                                                        true,
                                                    )
                                                "
                                                :rules="[form.allPricesValidated || '']"
                                                :readonly="multiVat"
                                                regular
                                                content-class="mr-1 oss-"
                                                :hide-details="true"
                                                v-model="form.single_prices.prices.vatAmount.value"
                                            >
                                                <template #label>
                                                    TVA
                                                    <!-- <span
                                                                v-if="confidence(form.single_prices.prices.vatAmount)"
                                                            >
                                                                (
                                                                <span
                                                                    :class="confidence(form.single_prices.prices.vatAmount) > 80 ? 'text-green' : 'text-red'"
                                                                >{{`${confidence(form.single_prices.prices.vatAmount)}%`}}</span>)
                                                            </span> -->
                                                </template>
                                            </oss-text-field>
                                        </v-col>
                                        <v-col cols="12" class="pr-1 pb-1">
                                            <v-select-filled
                                                :items="vatList"
                                                regular
                                                :hide-details="true"
                                                v-show="!multiVat"
                                                outlined
                                                :color="
                                                    priceTextColor_amountData(
                                                        form.single_prices.prices,
                                                        true,
                                                    )
                                                "
                                                :rules="[form.allPricesValidated || '']"
                                                @update:model-value="
                                                    onVatRateChange(
                                                        form.single_prices.prices,
                                                        $event,
                                                    )
                                                "
                                                @mouseover="
                                                    highlightField(
                                                        form.single_prices.prices.vatRate,
                                                        true,
                                                    )
                                                "
                                                @mouseout="
                                                    highlightField(
                                                        form.single_prices.prices.vatRate,
                                                        false,
                                                    )
                                                "
                                                :model-value="
                                                    form.single_prices.prices.vatType
                                                        ? form.single_prices.prices.vatRate.value.toString() +
                                                          form.single_prices.prices.vatType
                                                        : form.single_prices.prices.vatRate.value.toString()
                                                "
                                                density="compact"
                                            />
                                        </v-col>
                                        <v-col cols="12" class="pa-0">
                                            <v-icon
                                                color="blue"
                                                @click="toggleLink(form.single_prices.prices)"
                                                v-if="!multiVat"
                                                >{{
                                                    form.single_prices.prices.link
                                                        ? "$link"
                                                        : "$link_off"
                                                }}</v-icon
                                            >
                                        </v-col>
                                    </v-row>
                                    <template v-if="multiVat">
                                        <div
                                            style="display: flex"
                                            v-for="(subAmount, index) in form.subAmounts"
                                            :key="index"
                                        >
                                            <v-flex xs3 class="pa-0">
                                                <!-- <oss-text-field
                                                        v-model.number="form.multi_prices[`prices_${index}`][`netAmount_${index}`].value"
                                                        type="number"
                                                        @update:model-value="onMetadataChange(form.multi_prices[`prices_${index}`], `_${index}`, `netAmount_${index}`)"
                                                        @mouseover="highlightField(form.multi_prices[`prices_${index}`][`netAmount_${index}`], true)"
                                                        @mouseout="highlightField(form.multi_prices[`prices_${index}`][`netAmount_${index}`], false)"
                                                        :color="priceTextColor(form.multi_prices[`prices_${index}`],`_${index}`)"
                                                        :rules="[areRowPricesValidated(form.multi_prices[`prices_${index}`],`_${index}`) || '']"
                                                        regular
                                                        content-class="mr-1 oss-"
                                                        :hide-details="true"
                                                    >
                                                        <template #label>
                                                            HT {{ index }}
                                                        </template>
                                                    </oss-text-field> -->
                                                <oss-text-field
                                                    regular
                                                    dense
                                                    :hide-details="true"
                                                    outlined
                                                    @update:model-value="
                                                        onMetadataChange_amountData(
                                                            subAmount,
                                                            'netAmount',
                                                        )
                                                    "
                                                    @mouseover="
                                                        highlightField(subAmount.netAmount, true)
                                                    "
                                                    @mouseout="
                                                        highlightField(subAmount.netAmount, false)
                                                    "
                                                    :color="
                                                        priceTextColor_amountData(subAmount, false)
                                                    "
                                                    :rules="[
                                                        areRowPricesValidated_amountData(
                                                            form.single_prices.prices,
                                                            true,
                                                        ) || '',
                                                    ]"
                                                    v-model="subAmount.netAmount.value"
                                                >
                                                    <template v-slot:label>
                                                        HT {{ index + 1 }}
                                                        <!-- <span
                                                                    v-if="confidence(subAmount.netAmount)"
                                                                >
                                                                    (<span :class="confidence(subAmount.netAmount) > 80 ? '' : 'text-red'"
                                                                    >
                                                                        {{`${confidence(subAmount.netAmount)}%`}}
                                                                    </span>)
                                                                </span> -->
                                                    </template>
                                                </oss-text-field>
                                            </v-flex>
                                            <v-flex xs3 class="pa-0">
                                                <oss-text-field
                                                    regular
                                                    dense
                                                    :hide-details="true"
                                                    outlined
                                                    @update:model-value="
                                                        onMetadataChange_amountData(
                                                            subAmount,
                                                            'grossAmount',
                                                        )
                                                    "
                                                    @mouseover="
                                                        highlightField(subAmount.grossAmount, true)
                                                    "
                                                    @mouseout="
                                                        highlightField(subAmount.grossAmount, false)
                                                    "
                                                    :color="
                                                        priceTextColor_amountData(subAmount, false)
                                                    "
                                                    :rules="[
                                                        areRowPricesValidated_amountData(
                                                            form.single_prices.prices,
                                                            true,
                                                        ) || '',
                                                    ]"
                                                    v-model="subAmount.grossAmount.value"
                                                >
                                                    <template v-slot:label>
                                                        TTC {{ index + 1 }}
                                                        <!-- <span
                                                                    v-if="confidence(subAmount.grossAmount)"
                                                                >
                                                                    (
                                                                    <span
                                                                        :class="confidence(subAmount.grossAmount) > 80 ? '' : 'text-red'"
                                                                    >{{`${confidence(subAmount.grossAmount)}%`}}</span>)
                                                                </span> -->
                                                    </template>
                                                </oss-text-field>
                                            </v-flex>
                                            <v-flex xs3 class="pa-0">
                                                <oss-text-field
                                                    regular
                                                    dense
                                                    :hide-details="true"
                                                    outlined
                                                    @update:model-value="
                                                        onMetadataChange_amountData(
                                                            subAmount,
                                                            'vatAmount',
                                                        )
                                                    "
                                                    @mouseover="
                                                        highlightField(subAmount.vatAmount, true)
                                                    "
                                                    @mouseout="
                                                        highlightField(subAmount.vatAmount, false)
                                                    "
                                                    :color="
                                                        priceTextColor_amountData(subAmount, false)
                                                    "
                                                    :rules="[
                                                        areRowPricesValidated_amountData(
                                                            form.single_prices.prices,
                                                            true,
                                                        ) || '',
                                                    ]"
                                                    v-model="subAmount.vatAmount.value"
                                                >
                                                    <template v-slot:label>
                                                        TVA {{ index + 1 }}
                                                        <!-- <span
                                                                    v-if="confidence(subAmount.vatAmount)"
                                                                >
                                                                    (
                                                                    <span
                                                                        :class="confidence(subAmount.vatAmount) > 80 ? '' : 'text-red'"
                                                                    >{{`${confidence(subAmount.vatAmount)}%`}}</span>)
                                                                </span> -->
                                                    </template>
                                                </oss-text-field>
                                            </v-flex>
                                            <v-flex xs2 class="pa-0">
                                                <!-- <v-select
                                                            :items="vatList"
                                                            :color="priceTextColor(form.multi_prices[`prices_${index}`],`_${index}`)"
                                                            :rules="[areRowPricesValidated(form.multi_prices[`prices_${index}`],`_${index}`) || '']"
                                                            :value="vatList.findIndex(el => el.value === form.multi_prices[`prices_${index}`][`vatRate_${index}`].value) >= 0 ? form.multi_prices[`prices_${index}`][`vatRate_${index}`].value : 0"
                                                            @update:model-value="onSelectChange($event, form.multi_prices[`prices_${index}`], `_${index}`, `vatRate_${index}`)"
                                                            @mouseover.native="highlightField(form.multi_prices[`prices_${index}`][`vatRate_${index}`], true)"
                                                            @mouseout.native="highlightField(form.multi_prices[`prices_${index}`][`vatRate_${index}`], false)"
                                                            regular
                                                            class="mr-1 oss-"
                                                            :hide-details="true"
                                                        >
                                                            <template #label>
                                                                %TVA {{ index }}
                                                            </template>
                                                        </v-select> -->
                                                <v-select-filled
                                                    :items="
                                                        subAmount.sign === -1
                                                            ? vatListDiscount
                                                            : vatList
                                                    "
                                                    regular
                                                    :hide-details="true"
                                                    outlined
                                                    :color="
                                                        priceTextColor_amountData(subAmount, false)
                                                    "
                                                    :rules="[
                                                        areRowPricesValidated_amountData(
                                                            form.single_prices.prices,
                                                            true,
                                                        ) || '',
                                                    ]"
                                                    @update:model-value="
                                                        onVatRateChange(subAmount, $event)
                                                    "
                                                    @mouseover="
                                                        highlightField(subAmount.vatRate, true)
                                                    "
                                                    @mouseout="
                                                        highlightField(subAmount.vatRate, false)
                                                    "
                                                    :model-value="
                                                        subAmount.vatType
                                                            ? subAmount.vatRate.value.toString() +
                                                              subAmount.vatType
                                                            : subAmount.vatRate.value.toString()
                                                    "
                                                    density="compact"
                                                />
                                            </v-flex>
                                            <v-flex xs1 class="pa-0">
                                                <div class="inline-icon">
                                                    <!-- <v-icon
                                                                color="blue"
                                                                @click="toggleFieldSync(`multiPrices_${index}`, index)"
                                                                v-if="multiVat"
                                                            >{{ getFieldSync(`multiPrices_${index}`) ? 'link' : 'link_off' }}</v-icon> -->
                                                    <v-icon
                                                        color="blue"
                                                        @click="toggleLink(subAmount)"
                                                        v-if="multiVat"
                                                    >
                                                        {{ subAmount.link ? "$link" : "$link_off" }}
                                                    </v-icon>
                                                </div>
                                            </v-flex>
                                        </div>
                                    </template>
                                </v-flex>
                                <!-- subjectToVAT = false (grossAmount validation only) -->
                                <v-flex v-else>
                                    <oss-text-field
                                        @update:model-value="
                                            onMetadataChange(
                                                form.single_prices.prices,
                                                '',
                                                'grossAmount',
                                            )
                                        "
                                        @mouseover="
                                            highlightField(
                                                form.single_prices.prices.grossAmount,
                                                true,
                                            )
                                        "
                                        @mouseout="
                                            highlightField(
                                                form.single_prices.prices.grossAmount,
                                                false,
                                            )
                                        "
                                        :color="
                                            form.single_prices.prices.grossAmount.validated
                                                ? 'green'
                                                : 'red'
                                        "
                                        :success="form.single_prices.prices.grossAmount.validated"
                                        :error="!form.single_prices.prices.grossAmount.validated"
                                        :rules="[
                                            form.single_prices.prices.grossAmount.validated || '',
                                        ]"
                                        regular
                                        content-class="mr-1 oss-"
                                        :hide-details="true"
                                        :append-outer-icon="
                                            form.single_prices.prices.grossAmount.validated
                                                ? '$check_box'
                                                : '$check_box_outline_blank'
                                        "
                                        @click:append-outer="
                                            form.single_prices.prices.grossAmount.validated =
                                                !form.single_prices.prices.grossAmount.validated
                                        "
                                        v-model="form.single_prices.prices.grossAmount.value"
                                    >
                                        <template #label>
                                            TTC
                                            <span
                                                v-if="
                                                    confidence(
                                                        form.single_prices.prices.grossAmount,
                                                    )
                                                "
                                            >
                                                (
                                                <span
                                                    :class="
                                                        confidence(
                                                            form.single_prices.prices.grossAmount,
                                                        ) > 80
                                                            ? 'text-green'
                                                            : 'text-red'
                                                    "
                                                    >{{
                                                        `${confidence(
                                                            form.single_prices.prices.grossAmount,
                                                        )}%`
                                                    }}</span
                                                >)
                                            </span>
                                        </template>
                                    </oss-text-field>
                                </v-flex>
                                <!-- </v-form> -->
                            </v-card-text>
                        </v-window-item>
                        <v-window-item :value="7">
                            <v-card-text class="py-0">
                                <v-radio-group
                                    label="Type de TVA"
                                    v-model="document.vatType"
                                    :rules="[!!document.vatType || 'Type de VAT requise']"
                                    inline
                                    required
                                    color="primary"
                                >
                                    <v-radio
                                        label="Aucun"
                                        value="NO_VAT_TYPE"
                                        v-if="document.type !== 'SALES_INVOICE'"
                                    />
                                    <v-radio label="Intracom" value="INTRACOM" color="secondary" />
                                    <!-- not vat accountable account (document) -->
                                    <v-radio
                                        label="Export"
                                        value="EXPORT"
                                        v-if="document.type === 'SALES_INVOICE'"
                                    />
                                    <v-radio
                                        label="Import"
                                        value="IMPORT"
                                        color="secondary"
                                        v-else
                                    />
                                    <v-radio
                                        label="Autoliquidation"
                                        value="REVERSE_CHARGE"
                                        color="secondary"
                                    />
                                </v-radio-group>
                            </v-card-text>
                        </v-window-item>
                    </v-window>
                    <v-card-actions>
                        <v-btn
                            v-show="wizardStep > 1"
                            elevation="0"
                            outlined
                            rounded
                            @click="previousStep()"
                            size="small"
                        >
                            Précédent
                        </v-btn>
                        <v-spacer />
                        <v-btn rounded depressed @click="nextStep()" size="small">
                            Je valide
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-window-item>
            <v-window-item fill-height :value="1">
                <v-layout wrap>
                    <!-- <v-flex xs12 sm7 @click="showDocument = false" v-if="showDocument"> -->
                    <v-flex xs12 sm7>
                        <div style="text-align: center; width: 100%">
                            <div
                                style="
                                    position: relative;
                                    width: 100%;
                                    height: 0;
                                    padding: 0;
                                    padding-bottom: 141.4516129032258%;
                                "
                            >
                                <svg
                                    id="svg-document-validation-mobile"
                                    v-if="document"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="100%"
                                    :viewBox="`0 0 ${imageWidth} ${imageHeight}`"
                                    style="position: absolute; width: 100%; left: 0; top: 0"
                                    class="elevation-2"
                                >
                                    <image
                                        id="svg-image-document-validation-mobile"
                                        :xlink:href="document.signedUrl"
                                        x="0"
                                        y="0"
                                        :height="`${imageHeight}px`"
                                        :width="`${imageWidth}px`"
                                    />
                                </svg>
                            </div>
                        </div>
                    </v-flex>
                </v-layout>
            </v-window-item>
        </v-window>
        <!-- </v-card> -->
        <oss-dialog
            v-model="spreadPurchaseDialog"
            title="Etaler le montant sur plusieurs mois"
            @valid="spreadAmount"
            :validLoading="loading"
            :validDisabled="!spreadValid"
            width="800px"
        >
            <v-form v-model="spreadValid">
                <v-layout wrap xs12>
                    <v-flex xs12>
                        Pour les charges supérieures à 1000 euros vous pouvez répartir le montant
                        sur plusieurs mois
                    </v-flex>
                    <v-flex xs12>
                        <v-switch v-model="activateSpreadAmount" label="Etaler" />
                    </v-flex>
                    <v-flex xs12 v-show="activateSpreadAmount">
                        <oss-date-picker
                            v-bind:label="$t('shared.spreadStartDate')"
                            v-model="spreadStartDate"
                            v-bind:minDate="spreadMinStartDate"
                            v-bind:maxDate="spreadMaxStartDate"
                            v-bind:type="'month'"
                            v-bind:format="'MM/YYYY'"
                        >
                        </oss-date-picker>
                    </v-flex>
                    <v-flex xs12 mt-4 v-show="activateSpreadAmount">
                        <v-slider
                            v-model="spreadMounthCount"
                            :thumb-size="24"
                            thumb-label="always"
                            label="Nombre de mois"
                            min="2"
                            max="12"
                            color="secondary"
                            show-ticks
                        />
                    </v-flex>
                </v-layout>
            </v-form>
        </oss-dialog>
        <oss-dialog
            v-if="form.date"
            ref="dateDialog"
            v-model="dateDialog"
            v-model:return-value="form.date.value"
            persistent
            without-title
            width="290px"
        >
            <v-date-picker-wrapper
                v-model="form.date.value"
                hide-header
                scrollable
                color="secondary"
                @update:model-value="onDateChangeFromDatePicker()"
            >
                <v-btn @click="dateDialog = false" variant="text">Cancel</v-btn>
                <v-btn @click="$refs.dateDialog.save(form.date.value)" variant="text">OK</v-btn>
            </v-date-picker-wrapper>
        </oss-dialog>
        <Chat
            v-if="openChat"
            v-bind:id="document.chat ? document.chat.id : ''"
            v-bind:inShowMessage="open_chat"
            v-bind:chatTitle="'Document'"
            v-bind:chatSubtitle="getChatSubTitle()"
            :showSmartChat="wishStatus !== 'DENIED'"
            @messageSent="onMessageSent($event)"
            @showMessageChanged="onShowMessageChanged($event)"
        />

        <!-- ThirdPartyCompany -->
        <oss-dialog
            v-model="dialogSelectCompany"
            :title="'Choisir une société'"
            v-if="dialogSelectCompany"
            width="1000px"
        >
            <company-table
                :showGenericCompany="document.type !== 'SALES_INVOICE'"
                :showSupplierCompanies="document.type !== 'SALES_INVOICE'"
                :showConsumerCompanies="document.type === 'SALES_INVOICE'"
                :showCustomerCompanies="document.type === 'SALES_INVOICE'"
                :showExistingCompanies="false"
                :company="document.thirdPartyCompany ? document.thirdPartyCompany.name : ''"
                :siret="
                    document.thirdPartyCompany && document.thirdPartyCompany.siret
                        ? document.thirdPartyCompany.siret
                        : ''
                "
                :siren="
                    document.thirdPartyCompany && document.thirdPartyCompany.siren
                        ? document.thirdPartyCompany.siren
                        : ''
                "
                :vatNumber="
                    document.thirdPartyCompany && document.thirdPartyCompany.vatNumber
                        ? document.thirdPartyCompany.vatNumber
                        : ''
                "
                :parentCompanyId="selectedCompany.id"
                @select-company="companySelected"
            />
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import { getSiretValue } from "../../../src/services/companyServices";
import { truncate } from "../../services/stringServices";

import { DocumentValidationInvoiceBase } from "./DocumentValidationInvoiceBase";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component
export class DocumentValidationMobile extends DocumentValidationInvoiceBase {
    step: number = 0;

    get showDocument() {
        return !!this.step;
    }

    set showDocument(value) {
        this.step = value ? 1 : 0;
    }

    get thirdPartyCompanyName() {
        if (this.document.thirdPartyCompany) return this.document.thirdPartyCompany.name;
        return "";
    }

    set thirdPartyCompanyName(value) {
        if (this.document.thirdPartyCompany) this.document.thirdPartyCompany.name = value;
    }

    getCompanyName(company) {
        return truncate(company.shortName || company.name, 35);
    }

    beforeMount() {
        this.svgSuffix = "document-validation-mobile";
    }

    getSiretValue(siret: string) {
        return getSiretValue(siret);
    }
}

export default toNative(DocumentValidationMobile);
</script>

<style scoped lang="scss">
.v-text-field__details {
    min-height: 0px;
}
.v-messages {
    min-height: 0px;
}
</style>
